import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

// import AddUserModal from './AddUserModal';
import StaffTable from './../../../components/Staff/StaffTable';
import { getStaff, createStaff, resetPassword, updateStaff } from '../../../services/UserService';
import { getRolesAndPermissions } from '../../../services/RoleService';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StaffProduction = () => {
  
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteSessionPasswordModalOpen, setDeleteSessionPasswordModalOpen] = useState(false);
  const [deleteSessionStatusModalOpen, setDeleteSessionStatusModalOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [currentEmail, setCurrentEmail] = useState('');
  const [editingUserData, setEditingUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadStaffData = async () => {
    try {
      setLoading(true);
      const [usersData, rolesData] = await Promise.all([
        getStaff(),
        getRolesAndPermissions(),
      ]);
      setUsers(usersData);
      setRoles(rolesData.roles || []);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStaffData();
  }, []);

  const handleAddUser = async (newUser) => {
    try {
      const createdUser = await createStaff(newUser);
      setUsers([...users, createdUser]);
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };

  const handleResetPassword = async (email, newPassword, deleteSession) => {
    try {
      await resetPassword(email, newPassword, deleteSession);
    } catch (error) {
      console.error('Error resetting password:', error);
    }
  };

  const handleEditUser = async (userData) => {
    try {
      await updateStaff(userData);
      await loadStaffData();
    } catch (error) {
      console.error('Error resetting password:', error);
    }
  };

  const handleOpenSessionPasswordModal = (email, password) => {
    setCurrentEmail(email);
    setCurrentPassword(password);
    setDeleteSessionPasswordModalOpen(true);
  };

  const handleSessionPasswordModalClose = () => {
    setDeleteSessionPasswordModalOpen(false);
  };

  const handleSessionPasswordModalConfirm = (deleteSession) => {
    handleResetPassword(currentEmail, currentPassword, deleteSession);
    handleSessionPasswordModalClose();
  };

  const handleOpenSessionStatusModal = (email, data) => {
    setCurrentEmail(email);
    setEditingUserData({
      ...data,
      email,
      roleId: data.roleId ?? data.role?.id ?? '',
      dateOfAdmission: data.dateOfAdmission ? dayjs(data.dateOfAdmission) : dayjs(),
      birthdate: data.birthdate ? dayjs(data.birthdate) : (data.birthDate ? dayjs(data.birthDate) : dayjs()),
      deleteSession: false
    });
    setDeleteSessionStatusModalOpen(true);
  };

  const handleSessionStatusModalClose = () => {
    setDeleteSessionStatusModalOpen(false);
  };

  const handleSessionStatusModalConfirm = (deleteSession) => {
    handleEditUser({
      ...editingUserData,
      email: currentEmail,
      deleteSession
    });
    handleSessionStatusModalClose();
  };

  return (
    <div>
      <PageHeader title={t('staff')} subtitle={t('manage_users_and_roles')} />
      <StaffTable 
        users={users} 
        loading={loading}
        onRefresh={loadStaffData}
        onAddUser={() => setIsModalOpen(true)} 
        onResetPassword={(email, password) => {
          handleOpenSessionPasswordModal(email, password);
        }}
        onEditUser={(email, data) => {
          handleOpenSessionStatusModal(email, data);
        }}
        roles={roles}
      />
      {/* <AddUserModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleAddUser}
        roles={roles}
      /> */}
      <Dialog open={deleteSessionPasswordModalOpen} onClose={handleSessionPasswordModalClose}>
        <DialogTitle>{t('confirm_logout')}</DialogTitle>
        <DialogContent>
          <Typography>{t('confirm_logout_message')}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSessionPasswordModalClose}>{t('cancel')}</Button>
          <Button onClick={() => handleSessionPasswordModalConfirm(false)}>{t('no')}</Button>
          <Button onClick={() => handleSessionPasswordModalConfirm(true)} variant="contained" color="primary">{t('yes')}</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteSessionStatusModalOpen} onClose={handleSessionStatusModalClose}>
        <DialogTitle>{t('confirm_logout')}</DialogTitle>
        <DialogContent>
          <Typography>{t('confirm_logout_message')}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSessionStatusModalClose}>{t('cancel')}</Button>
          <Button onClick={() => handleSessionStatusModalConfirm(false)}>{t('no')}</Button>
          <Button onClick={() => handleSessionStatusModalConfirm(true)} variant="contained" color="primary">{t('yes')}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default StaffProduction;
